/**
 * toast.js
 * show toast and handle click + fadeout
 *
 */
import { Toast as OrbitBase } from "../../original/js/components/toast";

/**
* Declare constants
*/
const attributeBase = 'data-rs-toast';

export class Toast extends OrbitBase {

	constructor(element) {
		super(element)
		this.anchor = element.getAttribute(this.attributes.anchor);
		this.addAdditionalEventHandlers()
	}

	/**
	* Declare attribute constants
	*/
	get attributes() {
		return {
			show: `${attributeBase}-show`,
			anchor: `${attributeBase}-anchor`,
		}
	}

	addAdditionalEventHandlers() {
		// Add anchor trigger.
		if (this.anchor) {
			const pageAnchor = this.getUrlParam('toast');

			if (pageAnchor && this.anchor == pageAnchor) {
				this.show();
				this.destroyCloseTimeout();
				this.createCloseTimeOut();
			}
		}
	}

	/**
	 * Add event handlers
	 */
	addEventHandlers() {
		// handle click trigger element.
		// Check if triggerElement fix.
		if (this.triggerElement) {
			this.triggerElement.addEventListener('click', (clickEvent) => {
				clickEvent.preventDefault();
				this.show();
				this.destroyCloseTimeout();
				this.createCloseTimeOut();
			});
		}

    this.closeElement.addEventListener('click', () => {
      this.keystroke = 0;
    });

		this.element.addEventListener("mouseenter", () => {
			this.destroyCloseTimeout();
		});
		this.element.addEventListener("mouseleave", () => {
			// In OG file returns undefined which broke the timer when this event is trigger more than once.
			this.createCloseTimeOut();
		});
    document.addEventListener('keydown', (keydownEvent) => {
      this.handleButtonKeys(keydownEvent);
    });
    this.closeElement.addEventListener('click', () => {
      this.keystroke = 0;
      this.toastOpen = false;
    });
	}

	getUrlParam(param) {
		var params = window.location.href.split("#");
		var paramsMap = {};
		params.forEach(function (p) {
			var v = p.split("=");
			paramsMap[v[0]] = decodeURIComponent(v[1]);
		});

		return paramsMap[param] !== null ? paramsMap[param] : '';
	}

	hide() {
		super.hide();

		// Used in react apps to handle close.
		let event = new CustomEvent('toast-close');
		this.element.dispatchEvent(event);
	}

	// Not working correctly when toast is root element. In case where the root div is parrent element, toast is not hiding. There is an also a timer reset when on 'mouseleave', which cover the case.
	createCloseTimeOut() {
		this.closeTimeout = setTimeout(() => {
			this.hide();
		}, 10000);
	}
}
